import { create } from 'zustand'
import type { User } from 'firebase/auth'

export type AuthStatus = 'initial' | 'authenticated' | 'unauthenticated'

interface AuthState {
  status: AuthStatus
  user: User | null
  setUser: (user: User | null) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'initial',
  user: null,
  setUser: (user) =>
    set({
      user,
      status: user ? 'authenticated' : 'unauthenticated',
    }),
}))
